import React, { useState } from 'react';

import dynamic from 'next/dynamic';

import { FlightBookerError } from '@components/views/landing/components/booker/FlightTabContent';
import { usePageTransitionAnimation } from '@hooks/animations';
import { InitialFormValues } from '@components/views/types';
import { useDevice } from '@contexts/device';
import Typography from '@components/Typography';

import { Content, Footer, StyledButton, StyledSimpleButton } from './styled';

const Modal = dynamic(() => import('@components/Modal/next/Modal'));
const FlightTabContent = dynamic(
  () => import('@components/views/landing/components/booker/FlightTabContent')
);
const FlightSearchBarContainer = dynamic(
  () =>
    import(
      '@components/views/flight/listing/SearchBar/FlightSearchBarContainer'
    )
);

interface FlightSearchFormProps {
  onCancel?(): void;
  initialValues?: InitialFormValues;
  setShowLoader?: (value: boolean) => void;
  isHoliday?: boolean;
}

const FlightSearchForm = ({
  onCancel,
  initialValues,
  setShowLoader,
  isHoliday,
}: FlightSearchFormProps) => {
  const [url, setUrl] = useState('');
  const [flightError, setFlightError] = useState<
    FlightBookerError | undefined
  >();

  const [initialFlightError, setInitialFlightError] = useState<
    FlightBookerError | undefined
  >();
  const { isDesktop } = useDevice();
  const { isLoading } = usePageTransitionAnimation();

  const handleNavigate = () => {
    setFlightError(initialFlightError);
    if (
      initialFlightError?.location?.arriving ||
      initialFlightError?.location?.departure ||
      initialFlightError?.date
    )
      return;
    setShowLoader?.(true);
    window.open(url, '_self');
  };

  // ===============================================
  // Handle updating the href
  // ===============================================
  const onHrefUpdate = (href: string) => {
    setUrl(href);
  };
  return isDesktop ? (
    <Modal
      title={
        <Typography variant='Title4' weight='SemiBold' color='D400'>
          Uçak Ekleyin
        </Typography>
      }
      backgroundColor='lynxWhite'
      onCancel={onCancel}
      width={774}
      padding='44px'
      zIndex={98}
      borderRadius={8}
    >
      <Content>
        <FlightTabContent
          initialValues={initialValues}
          onHrefUpdate={onHrefUpdate}
          error={flightError}
          initialError={initialFlightError}
          href={url}
          setError={setFlightError}
          setInitialError={setInitialFlightError}
          borderRadius='8px'
          isTravelPlanning={true}
          isHoliday={isHoliday}
        />
      </Content>
      <Footer>
        <StyledSimpleButton onClick={onCancel}>Vazgeç</StyledSimpleButton>
        <StyledButton
          onClick={handleNavigate}
          disabled={isLoading}
          loading={isLoading}
          variant='Primary'
        >
          Uçuşları Listele
        </StyledButton>
      </Footer>
    </Modal>
  ) : (
    <FlightSearchBarContainer
      startDateResponsive={initialValues?.startDate || undefined}
      endDateResponsive={initialValues?.endDate || undefined}
      isSearchResultHeaderVisible={false}
      defaultSearchModalVisible={true}
      onCancel={onCancel}
      setShowLoader={setShowLoader}
      isHoliday={isHoliday}
      title={
        <Typography variant='Title4' weight='SemiBold' color='D400'>
          Uçak Ekleyin
        </Typography>
      }
      searchButtonTitle='Uçuşları Listele'
    />
  );
};

export default FlightSearchForm;
